import API_BASE_URL from '../config/api';
import React, { Component } from 'react';
import axios from 'axios';
import getBackupDifferences, { backupDifferencePriority, sortBackupDifferences } from '../utils/backup-differences';
import { Pedestrismo, PedestrismoBackup } from '../constants/enums';

class BackupDifferences extends Component {
  constructor(props) {
    super(props);
    this.state = { rows: [], loading: false, error: '', updatedAt: '', copying: false, message: '', copyError: '' };
    this.requestId = 0;
    this.load = this.load.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
    this.interval = setInterval(() => {
      if (this.props.open && this.props.visible && !this.props.uploading && !this.copyPending) this.load();
    }, 15000);
  }

  componentDidUpdate(previous) {
    if (previous.eventID !== this.props.eventID) {
      this.requestId += 1;
      this.pending = false;
      this.setState({ rows: [], error: '', updatedAt: '', loading: false, message: '', copyError: '' }, () => {
        if (this.props.open && this.props.visible) this.load();
      });
    } else if (!previous.uploading && this.props.uploading) {
      this.requestId += 1;
      this.pending = false;
      this.setState({ loading: false });
    } else if (this.props.open && this.props.visible && !this.props.uploading
      && (previous.uploading || !previous.visible || !previous.open)) {
      this.load();
    }
  }

  componentWillUnmount() {
    this.mounted = false;
    this.requestId += 1;
    clearInterval(this.interval);
  }

  async load() {
    if (!this.props.eventID || this.props.uploading || this.pending || this.copyPending) return;
    this.pending = true;
    const requestId = ++this.requestId;
    this.setState({ loading: true, error: '' });
    try {
      const response = await axios.get((API_BASE_URL + '/races/')
        + encodeURIComponent(this.props.eventID) + '/liverank', { timeout: 15000 });
      if (!this.mounted || requestId !== this.requestId) return;
      if (!response.data || (response.data.result !== null && !Array.isArray(response.data.result))) {
        throw new Error('La respuesta de resultados no tiene el formato esperado.');
      }
      this.setState({ rows: getBackupDifferences(response.data.result || []),
        updatedAt: new Date().toLocaleTimeString('es-AR') });
    } catch (error) {
      if (this.mounted && requestId === this.requestId) {
        this.setState({ error: 'No se pudo actualizar la comparación. ' + error.message });
      }
    } finally {
      if (this.mounted && requestId === this.requestId) {
        this.pending = false;
        this.setState({ loading: false });
      }
    }
  }

  async copyResult(row) {
    const { eventID, competition, onCopied, onCopyingChange } = this.props;
    if (this.copyPending || this.props.uploading || !eventID || !row.userID || !row.distanceID) return;
    const fromBackup = competition === Pedestrismo;
    if ((competition !== Pedestrismo && competition !== PedestrismoBackup) || (fromBackup ? row.missingBackup : row.missing)) return;
    this.copyPending = true;
    this.requestId += 1;
    this.pending = false;
    if (onCopyingChange) onCopyingChange(true);
    this.setState({ copying: true, loading: false, error: '', message: '', copyError: '' });
    try {
      const response = await axios.post((API_BASE_URL + '/races/')
        + encodeURIComponent(eventID) + '/user/' + encodeURIComponent(row.userID)
        + '/distance/' + encodeURIComponent(row.distanceID) + '/copy-result',
        { source: fromBackup ? 'backup' : 'principal' }, { timeout: 15000 });
      if (onCopied) onCopied(row, response.data.copied_time, eventID, fromBackup ? Pedestrismo : PedestrismoBackup);
      let message = 'Dorsal ' + row.number + ': tiempo copiado a ' + (fromBackup ? 'principal.' : 'backup.');
      try {
        await axios.post((API_BASE_URL + '/races/')
          + encodeURIComponent(eventID) + '/live-results-updated', {}, { timeout: 15000 });
      } catch (error) {
        message += ' No se pudo notificar a Live.';
      }
      if (this.mounted && this.props.eventID === eventID) this.setState({ message });
    } catch (error) {
      if (this.mounted && this.props.eventID === eventID) this.setState({ copyError:
        'No se pudo completar la copia. ' + (error.response && error.response.data
          && error.response.data.message ? error.response.data.message : error.message) });
    } finally {
      this.copyPending = false;
      if (onCopyingChange) onCopyingChange(false);
      if (this.mounted) {
        this.setState({ copying: false });
        this.load();
      }
    }
  }

  render() {
    const { rows, loading, error, updatedAt, copying, message, copyError } = this.state;
    const isBackup = this.props.competition === PedestrismoBackup;
    return <details className="floating-race-panel__backup" open={this.props.open}>
      <summary onClick={event => { event.preventDefault(); this.props.onToggle(); }}>
        Diferencias backup ({updatedAt ? rows.length : '—'})
      </summary>
      <div className="floating-race-panel__backup-content">
        <p>Diferencias mayores a 2 segundos o sin tiempo en alguna estación. Solo resultados subidos.</p>
        <button type="button" className={this.props.competition === PedestrismoBackup ? 'btn btn-danger btn-backup btn-xs' : 'btn btn-primary btn-xs'} onClick={this.load}
          disabled={loading || copying || this.props.uploading || !this.props.eventID}>
          {loading ? 'Actualizando…' : 'Actualizar'}
        </button>
        {!this.props.eventID && <p>Seleccioná un evento.</p>}
        {copyError && <p role="alert">{copyError}</p>}
        {message && <p role="status">{message}</p>}
        {error && <p role="alert">{error}{updatedAt && ' Se conserva la última comparación.'}</p>}
        {updatedAt && <small>Actualizado: {updatedAt}</small>}
        {updatedAt && rows.length === 0 && <p>No hay diferencias mayores a 2 segundos.</p>}
        {rows.length > 0 && <div className="floating-race-panel__backup-entries">
          <table className="floating-race-panel__recent-table">
            <caption className="sr-only">Comparación de tiempos principales y backup del evento</caption>
            <thead><tr><th scope="col">Dorsal</th><th scope="col">Tiempo</th><th scope="col">Backup</th><th scope="col">Acción</th></tr></thead>
            <tbody>{sortBackupDifferences(rows, isBackup).map(row => {
              const fromBackup = !isBackup;
              const actionLabel = fromBackup ? 'Copiar backup al principal' : 'Copiar principal al backup';
              const missing = row.missing || row.missingBackup;
              return <tr key={row.key}
              className={'backup-difference--' + (isBackup ? 'backup-' : 'primary-')
                + ['low', 'medium', 'high'][backupDifferencePriority(row, isBackup) - 1]}
              title={missing ? 'Revisar dorsal sin tiempo ' + (row.missing ? 'principal' : 'backup') : row.distance || ''}>
              <th scope="row">{row.number}</th>
              <td>{row.missing ? <strong>{row.time}</strong> : row.time}</td><td>{row.missingBackup ? <strong>{row.backup}</strong> : row.backup}</td>
              <td><button type="button" className={this.props.competition === PedestrismoBackup ? 'btn btn-danger btn-backup btn-xs' : 'btn btn-primary btn-xs'} title={actionLabel}
                aria-label={actionLabel + ' del dorsal ' + row.number}
                disabled={copying || loading || this.props.uploading || !row.userID || !row.distanceID
                  || (fromBackup ? row.missingBackup : row.missing)} onClick={() => this.copyResult(row)}>
                <span aria-hidden="true" className={'glyphicon glyphicon-arrow-' + (fromBackup ? 'left' : 'right')} />
              </button></td>
            </tr>;
            })}</tbody>
          </table>
        </div>}
      </div>
    </details>;
  }
}

export default BackupDifferences;



// WEBPACK FOOTER //
// ./src/containers/backup-differences.js